<template>
  <div
    :class="[
      'rate d-flex flex-row',
      {
        'rate--disabled': disabled,
        'rate--lg': size === 'lg'
      }
    ]"
  >
    <b-icon
      v-for="n in 5"
      :key="n"
      icon="star-fill"
      :class="{
        active: Math.floor(activeValue) >= n
      }"
      @click="rate(n)"
      @mouseover="setHoverValue(n)"
      @mouseleave="setHoverValue(null)"
    >
    </b-icon>
    <p v-if="hasLabel">{{ parseFloat(value) }}</p>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Rating
 * ==================================================================================
 **/

export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['md', 'lg'].indexOf(value) !== -1
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    activeValue() {
      return this.hoverValue ? this.hoverValue : parseFloat(this.value)
    }
  },
  data: function () {
    return {
      hoverValue: null
    }
  },
  methods: {
    rate(rating) {
      if (this.disabled) return
      this.$emit('input', rating)
      this.$emit('change', rating)
    },

    setHoverValue(value) {
      if (this.disabled) return
      this.hoverValue = value
    }
  }
}
</script>
<style scoped lang="scss">
.rate {
  p {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 1rem;
    margin-left: 10px;
  }

  .b-icon {
    width: 20px;
    color: #b5b5b5;
  }

  .b-icon.active {
    color: #ffd314;
  }
}

.rate:not(.rate--disabled) {
  .b-icon:hover {
    cursor: pointer;
    color: #ffd314;
  }
}

.rate--lg {
  .b-icon {
    width: 35px;
    height: 35px;
    margin-right: 25px;
    color: #e3e3e3;
  }
}

.rate--disabled,
.rate:disabled {
  .b-icon {
    cursor: inherit;
  }
}
</style>
